import { Filter, Product } from "@/types/index";
import { sortProducts } from "./sortBroadbandProducts";
import { filterProducts } from "./filterBroadbandProducts";

// Default Product Selector.

export const defaultProductSelector = (
	products: Array<Product>,
	contractFilters: Array<Filter>,
	networkFilters: Array<Filter>,
	speedFilters: Array<Filter>,
	sorter: string
) => {
	return sortProducts(
		filterProducts(products, contractFilters, networkFilters, speedFilters),
		sorter
	);
};

// Fibre Products Selector.

export const fibreProductSelector = (
	products: Array<Product>,
	contractFilters: Array<Filter>,
	networkFilters: Array<Filter>,
	speedFilters: Array<Filter>,
	sorter: string
) => {
	const sortedProducts = defaultProductSelector(
		products,
		contractFilters,
		networkFilters,
		speedFilters,
		sorter
	);

	return sortedProducts.filter((product: Product) => {
		return product.fibre === 1;
	});
};

// 12 Month Contract Products Selector.

export const twelveMonthProductSelector = (
	products: Array<Product>,
	contractFilters: Array<Filter>,
	networkFilters: Array<Filter>,
	speedFilters: Array<Filter>,
	sorter: string
) => {
	const sortedProducts = defaultProductSelector(
		products,
		contractFilters,
		networkFilters,
		speedFilters,
		sorter
	);

	return sortedProducts.filter((product: Product) => {
		return product.contract_length === "12";
	});
};

// Broadband with gifts Products Selector.

export const broadbandWithGiftsProductSelector = (
	products: Array<Product>,
	contractFilters: Array<Filter>,
	networkFilters: Array<Filter>,
	speedFilters: Array<Filter>,
	sorter: string
) => {
	const sortedProducts = defaultProductSelector(
		products,
		contractFilters,
		networkFilters,
		speedFilters,
		sorter
	);

	return sortedProducts.filter((product: Product) => {
		return product.extras.length !== 0;
	});
};

// TV Products Selector.

export const tvProductSelector = (
	products: Array<Product>,
	contractFilters: Array<Filter>,
	networkFilters: Array<Filter>,
	speedFilters: Array<Filter>,
	sorter: string
) => {
	const sortedProducts = defaultProductSelector(
		products,
		contractFilters,
		networkFilters,
		speedFilters,
		sorter
	);

	return sortedProducts.filter((product: Product) => {
		return product.tv === 1;
	});
};

// Network Products Selector.

// BT Products Selector
export const BTProductSelector = (
	products: Array<Product>,
	contractFilters: Array<Filter>,
	speedFilters: Array<Filter>,
	sorter: string
) => {
	const networkFilters = [
		{
			name: "BT",
			value: "BT",
			isChecked: true,
		},
	];

	return defaultProductSelector(
		products,
		contractFilters,
		networkFilters,
		speedFilters,
		sorter
	);
};

//TalkTalk Products Selector.
export const TalkTalkProductSelector = (
	products: Array<Product>,
	contractFilters: Array<Filter>,
	speedFilters: Array<Filter>,
	sorter: string
) => {
	const networkFilters = [
		{
			name: "TalkTalk",
			value: "TalkTalk",
			isChecked: true,
		},
	];

	return defaultProductSelector(
		products,
		contractFilters,
		networkFilters,
		speedFilters,
		sorter
	);
};

//Sky Products Selector.
export const SkyProductSelector = (
	products: Array<Product>,
	contractFilters: Array<Filter>,
	speedFilters: Array<Filter>,
	sorter: string
) => {
	const networkFilters = [
		{
			name: "Sky",
			value: "Sky",
			isChecked: true,
		},
	];

	return defaultProductSelector(
		products,
		contractFilters,
		networkFilters,
		speedFilters,
		sorter
	);
};

//Plusnet Products Selector.
export const PlusnetProductSelector = (
	products: Array<Product>,
	contractFilters: Array<Filter>,
	speedFilters: Array<Filter>,
	sorter: string
) => {
	const networkFilters = [
		{
			name: "Plusnet",
			value: "Plusnet",
			isChecked: true,
		},
	];

	return defaultProductSelector(
		products,
		contractFilters,
		networkFilters,
		speedFilters,
		sorter
	);
};

//Virgin Media Products Selector.
export const VirginMediaProductSelector = (
	products: Array<Product>,
	contractFilters: Array<Filter>,
	speedFilters: Array<Filter>,
	sorter: string
) => {
	const networkFilters = [
		{
			name: "Virgin Media",
			value: "Virgin Media",
			isChecked: true,
		},
	];

	return defaultProductSelector(
		products,
		contractFilters,
		networkFilters,
		speedFilters,
		sorter
	);
};

//Vodafone Products Selector.
export const VodafoneProductSelector = (
	products: Array<Product>,
	contractFilters: Array<Filter>,
	speedFilters: Array<Filter>,
	sorter: string
) => {
	const networkFilters = [
		{
			name: "Vodafone",
			value: "Vodafone",
			isChecked: true,
		},
	];

	return defaultProductSelector(
		products,
		contractFilters,
		networkFilters,
		speedFilters,
		sorter
	);
};

//EE Products Selector.
export const EEProductSelector = (
	products: Array<Product>,
	contractFilters: Array<Filter>,
	speedFilters: Array<Filter>,
	sorter: string
) => {
	const networkFilters = [
		{
			name: "EE",
			value: "EE",
			isChecked: true,
		},
	];

	return defaultProductSelector(
		products,
		contractFilters,
		networkFilters,
		speedFilters,
		sorter
	);
};

//NOW Broadband Products Selector.
export const NOWProductSelector = (
	products: Array<Product>,
	contractFilters: Array<Filter>,
	speedFilters: Array<Filter>,
	sorter: string
) => {
	const networkFilters = [
		{
			name: "NOW",
			value: "NOW",
			isChecked: true,
		},
	];

	return defaultProductSelector(
		products,
		contractFilters,
		networkFilters,
		speedFilters,
		sorter
	);
};
